import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { Button, Form } from "react-bootstrap";
import { inRange, isEmpty, startCase } from "lodash";
import { useNavigate } from "react-router-dom";

const RenderSlip = () => {
  const navigate = useNavigate();
  const {
    setBetSlipObject,
    betSlipObject,
    setResetBetPosition,
    handelPlaceFancy,
    handelPlaceBookmaker,
    limit,
    handelPlaceBetFair,
    setShowBetDialog,handelPlaceToss,handelPlaceBookmakerWifi
  } = useContext(BetSlipContext);
  const { profileData, user, setLoginModal, } = useContext(AuthContext);
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFair" ||
        betSlipObject?.playType == "multi"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }else if (betSlipObject?.playType == "wifiBookmaker") {
        handelPlaceBookmakerWifi();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };
  const inputRef = useRef(null);
  useEffect(() => {
    inputRef.current?.focus();
  });
  const RenderSlipComp = () => {
    return (
      <>
        <div
          style={{ paddingTop: "10px" }}
          className="d-flex justify-content-end align-items-center w-100"
        >
          <div className="d-flex align-items-center justify-content-end w-50">
            {" "}
            <div
              style={{ color: "black", fontWeight: "600", marginRight: "10px" }}
            >
              {betSlipObject?.teamName} - {startCase(betSlipObject?.playType)}
            </div>
            <Form.Control
              disabled={true}
              value={
                betSlipObject?.playType == "fancy"
                  ? `${betSlipObject?.odds}/${betSlipObject?.object?.pt}`
                  : betSlipObject?.odds
              }
              style={{
                height: "28px",
                fontSize: "15px",
                width: "90px",
                borderRadius: "5px",
                fontWeight: "600",
              }}
              className="me-2 mb-0"
              aria-label="First name"
            />
            <Form.Control
              value={betSlipObject?.bidPrice}
              style={{
                height: "28px",
                fontSize: "15px",
                width: "90px",
                borderRadius: "5px",
                fontWeight: "600",
              }}
              ref={inputRef}
              onChange={(e) =>
                setBetSlipObject({
                  ...betSlipObject,
                  bidPrice: e?.target?.value,
                })
              }
              type="number"
              className="me-2 mb-0"
              aria-label="First name"
            />{" "}
          </div>
        </div>

        <div
          style={{
            background: ["back", "Yes"].includes(betSlipObject?.betType)
              ? "#b7d5eb"
              : "#f6e6ea",
            padding: "6px 5px",
          }}
          className="mt-2 d-flex justify-content-end align-items-center w-100"
        >
          {" "}
          {(profileData?.editOneClickBetStake?.length > 0
            ? profileData?.editOneClickBetStake
            : number
          )?.map((res) => {
            return (
              <span
                style={{
                  cursor: "pointer",
                  background: ["back", "Yes"].includes(betSlipObject?.betType)
                    ? "rgb(110, 185, 238)"
                    : "#feafb2",
                  color: "black",
                  width: "auto",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
                onClick={() => {
                  setBetSlipObject({
                    ...betSlipObject,
                    bidPrice: isEmpty(betSlipObject?.bidPrice)
                      ? Number(res)
                      : Number(betSlipObject?.bidPrice) + Number(res),
                  });
                }}
                className="stake-value me-1 mb-0"
              >
                +{res}
              </span>
            );
          })}
          <Button
            disabled={bidPriceDisabled}
            onClick={() => {
              placeBet();
            }}
            style={{
              fontSize: "13px",
              width: "100px",
              borderRadius: "5px",
              lineHeight: "normal",
              marginRight: "6px",
            }}
            variant="secondary"
            className="btn-green"
            size="sm"
          >
            Place bid
          </Button>{" "}
          <Button
            style={{
              fontSize: "13px",
              width: "100px",
              borderRadius: "5px",
              lineHeight: "normal",
            }}
            onClick={() => setResetBetPosition(true)}
            variant="primary"
            className="btn-red me-1"
            size="sm"
          >
            Cancel
          </Button>
        </div>
      </>
    );
  };
  return betSlipObject?.playType != "fancy" ? (
    <tr>
      <td
        style={{
          background: ["back", "Yes"].includes(betSlipObject?.betType)
            ? "rgb(110, 185, 238)"
            : "#feafb2",
          marginTop: "8px",
        }}
        colSpan={2}
      >
        <RenderSlipComp />
      </td>
    </tr>
  ) : (
    <div
      style={{
        background: ["back", "Yes"].includes(betSlipObject?.betType)
          ? "rgb(110, 185, 238)"
          : "#feafb2",
      }}
    >
      <RenderSlipComp />
    </div>
  );
};

export default React.memo(RenderSlip);

const number = [25, 50, 100, 1000, 10000, 25000];
